
(function () {
  function initProduct(root) {
    var script = root.querySelector('[data-v2-variants]');
    if (!script) return;
    var variants;
    try { variants = JSON.parse(script.textContent || '[]'); } catch (error) { return; }
    if (!variants.length) return;

    var selected = { style: variants[0].style, color: variants[0].color, pack: variants[0].pack };
    var mainImage = root.querySelector('[data-v2-main-image]');
    var mainImageLink = root.querySelector('[data-v2-main-image-link]');
    var thumbs = root.querySelector('[data-v2-gallery-thumbs]');
    var amazonLinks = root.querySelectorAll('[data-v2-amazon-link]');
    var currentLabel = root.querySelector('[data-v2-current-label]');
    var scrollButtons = root.querySelectorAll('[data-v2-gallery-scroll]');

    function setActiveThumb(button) {
      if (!thumbs) return;
      thumbs.querySelectorAll('[data-v2-gallery-image]').forEach(function (item) {
        var active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
    }

    function showPhoto(photo, button) {
      if (mainImage && photo) {
        mainImage.src = photo.image;
        mainImage.alt = photo.alt || (root.dataset.productTitle || 'Product');
        if (mainImageLink) mainImageLink.href = photo.image;
      }
      setActiveThumb(button);
    }

    function updateScrollControls() {
      if (!thumbs) return;
      var overflow = thumbs.scrollWidth > thumbs.clientWidth + 2;
      scrollButtons.forEach(function (button) { button.hidden = !overflow; });
    }

    function renderGallery(variant) {
      if (!thumbs) return;
      var gallery = Array.isArray(variant.gallery) && variant.gallery.length ? variant.gallery : [{
        image: variant.image,
        alt: (root.dataset.productTitle || 'Product') + ' — ' + variant.label,
        sourceOrder: 0
      }];
      thumbs.textContent = '';
      gallery.forEach(function (photo, index) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'cv2-gallery__thumb' + (index === 0 ? ' is-active' : '');
        button.dataset.v2GalleryImage = photo.image;
        button.dataset.v2GalleryAlt = photo.alt || '';
        button.setAttribute('aria-label', 'View product image ' + (index + 1));
        button.setAttribute('aria-pressed', String(index === 0));
        var image = document.createElement('img');
        image.src = photo.image;
        image.alt = '';
        image.loading = index === 0 ? 'eager' : 'lazy';
        button.appendChild(image);
        button.addEventListener('click', function () { showPhoto(photo, button); });
        thumbs.appendChild(button);
      });
      showPhoto(gallery[0], thumbs.querySelector('[data-v2-gallery-image]'));
      updateScrollControls();
    }

    function applyVariant(variant) {
      if (!variant) return;
      selected.style = variant.style;
      selected.color = variant.color;
      selected.pack = variant.pack;
      root.dataset.currentAsin = variant.asin;
      renderGallery(variant);
      amazonLinks.forEach(function (link) { link.href = variant.url; });
      if (currentLabel) currentLabel.textContent = variant.label;
      root.querySelectorAll('[data-v2-option]').forEach(function (fieldset) {
        var key = fieldset.dataset.v2Option;
        var current = fieldset.querySelector('[data-v2-current-option="' + key + '"]');
        if (current) current.textContent = selected[key];
        fieldset.querySelectorAll('[data-v2-value]').forEach(function (button) {
          button.setAttribute('aria-pressed', String(button.dataset.v2Value === selected[key]));
        });
      });
    }

    function trackAmazonClick(event) {
      if (typeof window.calffyIsInternalBrowser === 'function' &&
          window.calffyIsInternalBrowser()) return;
      if (typeof window.gtag !== 'function') return;
      var link = event.currentTarget;
      var asin = root.dataset.currentAsin || '';
      var linkUrl = link.href || '';
      window.gtag('event', 'amazon_click', {
        item_id: asin,
        item_name: root.dataset.productTitle || document.title,
        link_url: linkUrl,
        outbound: true,
        transport_type: 'beacon'
      });
    }

    amazonLinks.forEach(function (link) {
      link.addEventListener('click', trackAmazonClick);
    });

    root.querySelectorAll('[data-v2-option]').forEach(function (fieldset) {
      var key = fieldset.dataset.v2Option;
      fieldset.querySelectorAll('[data-v2-value]').forEach(function (button) {
        button.addEventListener('click', function () {
          selected[key] = button.dataset.v2Value;
          var match = variants.find(function (variant) {
            return variant.style === selected.style && variant.color === selected.color && variant.pack === selected.pack;
          });
          if (match) applyVariant(match);
        });
      });
    });

    scrollButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (!thumbs) return;
        var direction = button.dataset.v2GalleryScroll === 'next' ? 1 : -1;
        thumbs.scrollBy({ left: direction * Math.max(180, thumbs.clientWidth * 0.8), behavior: 'smooth' });
      });
    });
    if (thumbs) thumbs.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        thumbs.scrollBy({ left: event.key === 'ArrowRight' ? 180 : -180, behavior: 'smooth' });
      }
    });
    window.addEventListener('resize', updateScrollControls);
    applyVariant(variants[0]);
  }

  function initMenus() {
    document.querySelectorAll('[data-v2-menu-toggle]').forEach(function (button) {
      var panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;
      function setOpen(open) {
        panel.hidden = !open;
        button.setAttribute('aria-expanded', String(open));
      }
      button.addEventListener('click', function () { setOpen(panel.hidden); });
      panel.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () { setOpen(false); });
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !panel.hidden) {
          setOpen(false);
          button.focus();
        }
      });
      if (new URLSearchParams(window.location.search).get('menu') === 'open') setOpen(true);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-v2-product]').forEach(initProduct);
    initMenus();
  });
})();
